export default {
  install (Vue, options) {
    // console.log('Installing GMP_DataViz hashPlugin...')
    Vue.prototype.$hashPlugin = {
      /*
       * === deserialize ===
       * matrix@air,water,soil@@compund@hcb,pcb18@@site@187,908,2093 =>
       * [{code: 'matrix', options: 'air, water, soil'}, {code: 'compound', options: 'hcb, pcb18'}, {code: 'site', options: 'GMP-A-0000506, GMP-B-0000476'}]
       * @param {String} string - hash
       * @param {type} string - 'filters', 'settings'
       * @returns {Array}
       */
      stringToArray (string, type) {
        let str = string
        let hash
        if (str) {
          hash = str.split('@@')
        } else {
          hash = []
        }
        let hashArray = []
        if (hash.length > 0) {
          hash.forEach(item => {
            let itemArray = item.split('@')
            if (itemArray[0]) {
              let itemObj = {}
              if (type === 'filters') {
                itemObj = {
                  code: itemArray[0],
                  options: itemArray[1] ? itemArray[1] : ''
                }
                if (itemObj.options.length) {
                  hashArray.push(itemObj)
                }
              } else if (type === 'settings') {
                itemObj = {
                  settingCode: itemArray[0],
                  settingValue: itemArray[1] ? itemArray[1] : ''
                }
                if (itemObj.settingValue.length) {
                  hashArray.push(itemObj)
                }
              }
            }
          })
        }
        return hashArray
      },

      /*
       * === serialize ===
       * [{code: 'matrix', options: 'air, water, soil'}, {code: 'compound', options: 'hcb, pcb18'}, {code: 'site', options: 'GMP-A-0000506, GMP-B-0000476'}]  =>
       * matrix@air,water,soil@@compund@hcb,pcb18@@site@187,908,2093
       * @param {Array} array - pole pro hash
       * @param {type} string - 'filters', 'settings'
       * @returns {String}
       */
      arrayToString (array, type) {
        let string = ''
        let arr = array
        arr.forEach((hashItem, index) => {
          if (index < arr.length - 1) {
            if (type === 'filters') {
              string += hashItem.code + '@' + hashItem.options + '@@'
            } else if (type === 'settings') {
              string += hashItem.settingCode + '@' + hashItem.settingValue + '@@'
            }
          } else {
            if (type === 'filters') {
              string += hashItem.code + '@' + hashItem.options
            } else if (type === 'settings') {
              string += hashItem.settingCode + '@' + hashItem.settingValue
            }
          }
        })
        return string
      },

      /*
       * vraci pole filtru pro dotaz na API (vylouci z hashe filtry ktere nejsou v lokalnim overridu)
       * @param {Array} filtersValuesLocal - lokalni override filtru
       * @param {Array} filtersArr - pole filtru z hashe
       * @returns {Array}
       */
      apiFilters (filtersValuesLocal, filtersArr) {
        let filteredArr = []
        filtersValuesLocal.filter(filter => filter.isEnabled).map(filter => filter.code).forEach(item => {
          if (filtersArr.find(fil => fil.code === item)) {
            filteredArr.push(filtersArr.find(fil => fil.code === item))
          }
        })
        return filteredArr
      },

      /*
       * vraci pole settings pro dotaz na API (vylouci z hashe settings ktere nejsou v lokalnim overridu)
       * @param {Array} settingsValuesLocal - lokalni override settings
       * @param {Array} settingsArr - pole settings z hashe
       * @returns {Array}
       */
      apiSettings (settingsValuesLocal, settingsArr) {
        let filteredArr = []
        settingsValuesLocal.map(setting => setting.code).forEach(item => {
          if (settingsArr.find(sett => sett.settingCode === item)) {
            filteredArr.push(settingsArr.find(sett => sett.settingCode === item))
          }
        })
        return filteredArr
      },

      /*
       * vraci string filtru do hashe pro API
       * @param {String} routeHash - $route.hash
       * @param {Array} localFilters - lokalni filtry
       * @returns {String}
       */
      filtersHash (routeHash, localFilters) {
        let filtersArr = Vue.prototype.$hashPlugin.stringToArray(routeHash.substr(1).split('|')[0], 'filters')
        let filtersHash = '/-'
        if (Vue.prototype.$hashPlugin.arrayToString(Vue.prototype.$hashPlugin.apiFilters(localFilters, filtersArr), 'filters').length > 0) {
          filtersHash = '/' + Vue.prototype.$hashPlugin.arrayToString(Vue.prototype.$hashPlugin.apiFilters(localFilters, filtersArr), 'filters')
        }
        return filtersHash
      },

      /*
       * vraci string settings do hashe pro API
       * @param {String} routeHash - $route.hash
       * @param {Array} localSettings - lokalni settings
       * @returns {String}
       */
      settingsHash (routeHash, localSettings) {
        let settingsArr = Vue.prototype.$hashPlugin.stringToArray(routeHash.substr(1).split('|')[1], 'settings')
        let settingsHash = ''
        if (Vue.prototype.$hashPlugin.arrayToString(Vue.prototype.$hashPlugin.apiSettings(localSettings, settingsArr), 'settings').length > 0) {
          settingsHash = '/' + Vue.prototype.$hashPlugin.arrayToString(Vue.prototype.$hashPlugin.apiSettings(localSettings, settingsArr), 'settings')
        }
        return settingsHash
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/hashPlugin.js